import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BlogsModule } from './components/blogs/blogs.module';
import { DashboardModule } from "./components/dashboard/dashboard.module";
import { SharedModule } from "./shared/shared.module";
import { ProductsModule } from "./components/products/products.module";
import { SalesModule } from "./components/sales/sales.module";
import { CouponsModule } from "./components/coupons/coupons.module";
import { PagesModule } from "./components/pages/pages.module";
import { MediaModule } from "./components/media/media.module";
import { MenusModule } from "./components/menus/menus.module";
import { VendorsModule } from "./components/vendors/vendors.module";
import { UsersModule } from "./components/users/users.module";
import { LocalizationModule } from "./components/localization/localization.module";
import { InvoiceModule } from "./components/invoice/invoice.module";
import { SettingModule } from "./components/setting/setting.module";
import { ReportsModule } from "./components/reports/reports.module";
import { AuthModule } from "./components/auth/auth.module";
import { SectionModule } from "./components/section/section.module";
import { PlacementsnewsModule } from "./components/placementsnews/placementsnews.module";
import { NewsModule } from "./components/news/news.module";
import { CourseModule } from "./components/courses/course.module";
import { FeesModule } from "./components/fees/fees.module";
import { CurriculumModule } from "./components/curriculum/curriculum.module";
import { EligibilityModule } from "./components/eligibility/eligibility.module";
import { MoredetailsModule } from "./components/moredetails/moredetails.module";
import { PlacementsModule } from "./components/placements/placements.module";
import { HomebannermenuModule } from "./components/homebannermenu/homebannermenu.module";
import { AboutusOverviewModule } from "./components/aboutus-overview/aboutus-overview.module";
import { RankingsModule } from "./components/rankings/rankings.module";
import { LeadershipModule } from "./components/leadership/leadership.module";
import { CommittesModule } from "./components/committes/committes.module";
import { StudentstoriesModule } from "./components/studentstories/studentstories.module";
import { CampusModule } from "./components/campus/campus.module";
import { FacilitiesoverviewModule } from "./components/facilitiesoverview/facilitiesoverview.module";
import { HomeRankSectionModule } from "./components/homeranksection/homeranksection.module";
import { HkbkplacementsModule } from "./components/hkbkplacements/hkbkplacements.module";
import { PlacementsOtherinfoModule } from "./components/hkbkplacements-otherinfo/hkbkplacements-otherinfo.module";
import { PlacementsStudentsPlacedModule } from "./components/hkbkplacements-students-placed/hkbkplacements-students-placed.module";
import { AcademicsModule } from "./components/academics/academics.module";
import { FacultyModule } from "./components/faculty/faculty.module";

import { AdvancedengineeringModule } from "./components/advancedengineering/advancedengineering.module";
import { InstitutionsModule } from "./components/institutions/institutions.module";
import { IqacHeadingModule } from "./components/iqacheading/iqacheading.module";
import { IqacSubHeadingModule } from "./components/iqac-subheading/iqac-subheading.module";
import { IqacContentModule } from "./components/iqac-content/iqac-content.module";
import { IICModule } from "./components/institute-industry-connect/institute-industry-connect.module";
import { FacilitiyModule } from "./components/facility/facility.module";
import { LearningResourcesModule } from "./components/learning-resources/learning-resources.module";
import { LearningResourcesUploadsModule } from "./components/learning-resources-uploads/learning-resources-uploads.module";
import { FilespathModule } from "./components/files-path/files-path.module";
import { HomeSliderModule } from "./components/home-slider/home-slider.module";
import { InstitutionsSliderModule } from "./components/institutions-slider/institutions-slider.module";
import { HowToApplyModule } from "./components/how-to-apply/how-to-apply.module";
import { IndianStudentsModule } from "./components/indian-students/indian-students.module";
import { InternationalStudentsModule } from "./components/international-students/international-students.module";
import { NewsYearModule } from "./components/news-year/news-year.module";
import { StudentsAchievementsModule } from "./components/students-achievements/students-achievements.module";
import { DepartmentSpotlightModule } from "./components/department-spotlight/department-spotlight.module";
import { InstitutionsInfoModule } from "./components/institutions-info/institutions-info.module";
import { TestimonialsModule } from "./components/testimonials/testimonials.module";
import { HkbkfacilitiesModule } from "./components/hkbkfacilities/hkbkfacilities.module";
import { HkbkfacilitiesHeadingModule } from "./components/hkbkfacilities-heading/hkbkfacilities-heading.module";
import { GalleryHeadingModule } from "./components/gallery-heading/gallery-heading.module";
import { GalleryModule } from "./components/gallery/gallery.module";
import { FacultyDepartmentModule } from "./components/faculty-department/faculty-department.module";
import { LibraryModule } from "./components/library/library.module";
import { InsuranceModule } from "./components/insurance/insurance.module";
import { ObjectiveModule } from "./components/objective/objective.module";
import { MessagesModule } from "./components/messages/messages.module";
import { AchievementsModule } from "./components/achievements/achievements.module";
import { UpcomingeventsModule } from "./components/upcomingevents/upcomingevents.module";
import { AlumniFeedbackModule } from "./components/alumni-feedback/alumni-feedback.module";
import { CourseFeedbackModule } from "./components/course-feedback/course-feedback.module";
import { InfrastructureFeedbackModule } from "./components/infrastructure-feedback/infrastructure-feedback.module";
import { ParentsFeedbackModule } from "./components/parents-feedback/parents-feedback.module";
import { RecruiterModule } from "./components/recruiter/recruiter.module";
import { HomepageOverviewModule } from "./components/homepage-overview/homepage-overview.module";
import { CampusNewsEventsModule } from "./components/campus-news-events/campus-news-events.module";
import { NaacHeadingModule } from "./components/naac-heading/naac-heading.module";
import { NaacSubHeadingModule } from "./components/naac-sub-heading/naac-sub-heading.module";
import { ClubTypeModule } from "./components/club-type/club-type.module";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
//import { BlogsModule } from './components/blogs/blogs.module';
import { fakeBackendProvider } from "./_helper/fake-backend";
import { JwtInterceptor } from "./_helper/jwt.interceptor";
import { ErrorInterceptor } from "./_helper/error.interceptor";
import { HomeComponent } from "./home/home.component";
import { AdminComponent } from "./admin/admin.component";
import { LoginComponent } from "./components/auth/login/login.component";

const api_endpoint = "https://api.onesb.edu.in/v2"; //https://hkbkdegreecollege.com/api/v2   https://onesb.edu.in/api/v2   //http://localhost:3001/v2

@NgModule({
  declarations: [AppComponent, HomeComponent, AdminComponent, LoginComponent],
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule.withServerTransition({ appId: "serverApp" }),
    HttpClientModule,
    AppRoutingModule,
    DashboardModule,
    InvoiceModule,
    SettingModule,
    BlogsModule,
    ReportsModule,
    AuthModule,
    SharedModule,
    LocalizationModule,
    ProductsModule,
    SalesModule,
    VendorsModule,
    CouponsModule,
    PagesModule,
    MediaModule,
    MenusModule,
    UsersModule,
    SectionModule,
    PlacementsnewsModule,
    NewsModule,
    CourseModule,
    FeesModule,
    CurriculumModule,
    EligibilityModule,
    MoredetailsModule,
    PlacementsModule,
    HomebannermenuModule,
    AboutusOverviewModule,
    RankingsModule,
    LeadershipModule,
    CommittesModule,
    StudentstoriesModule,
    CampusModule,
    FacilitiesoverviewModule,
    HomeRankSectionModule,
    HkbkplacementsModule,
    PlacementsOtherinfoModule,
    PlacementsStudentsPlacedModule,
    AcademicsModule,
    FacultyModule,
    AdvancedengineeringModule,
    InstitutionsModule,
    IqacHeadingModule,
    IqacSubHeadingModule,
    IqacContentModule,
    IICModule,
    FacilitiyModule,
    LearningResourcesModule,
    LearningResourcesUploadsModule,
    FilespathModule,
    HomeSliderModule,
    InstitutionsSliderModule,
    HowToApplyModule,
    IndianStudentsModule,
    InternationalStudentsModule,
    NewsYearModule,
    StudentsAchievementsModule,
    DepartmentSpotlightModule,
    InstitutionsInfoModule,
    TestimonialsModule,
    HkbkfacilitiesHeadingModule,
    HkbkfacilitiesModule,
    GalleryHeadingModule,
    GalleryModule,
    FacultyDepartmentModule,
    LibraryModule,
    InsuranceModule,
    ObjectiveModule,
    MessagesModule,
    AchievementsModule,
    UpcomingeventsModule,
    AlumniFeedbackModule,
    CourseFeedbackModule,
    InfrastructureFeedbackModule,
    ParentsFeedbackModule,
    RecruiterModule,
    CampusNewsEventsModule,
    NaacHeadingModule,
    NaacSubHeadingModule,
    HomepageOverviewModule,
    ClubTypeModule,
    BlogsModule,
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: "API_ENDPOINT", useValue: api_endpoint },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

    // provider used to create fake backend
    // fakeBackendProvider
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
